@use "/src/styles/functions";

.notifCard {
  display: flex;
  flex-direction: column;
  border-radius: functions.radius(8);
  gap: functions.space(12);
  transition: all 0.3s ease-in-out;
  --notif-backgroud-color: rgba(var(--theme-state-information-base));
  --notif-border-color: transparent;
  background-color: var(--notif-backgroud-color);
  border: 1px solid var(--notif-border-color);
  font-family:
    Yekan Bakh,
    system-ui,
    -apple-system,
    "Segoe UI",
    Roboto,
    "Helvetica Neue",
    Arial,
    "Noto Sans",
    "Liberation Sans",
    sans-serif,
    "Apple Color Emoji",
    "Segoe UI Emoji",
    "Segoe UI Symbol",
    "Noto Color Emoji";

  &__head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: functions.space(8);
  }

  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 auto;
  }

  &__title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-grow: 1;
    text-align: start;
  }

  &__action {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 auto;
  }

  &__close {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 auto;
  }

  &__notifCardBottomAction {
    display: flex;
    width: 100%;
    justify-content: flex-start;
    align-items: center;
  }

  &[data-size="x-small"] {
    padding: functions.space(8);
  }
  &[data-size="small"] {
    padding: functions.space(8) functions.space(10);
  }
  &[data-size="large"] {
    padding: functions.space(14) functions.space(14) functions.space(16)
      functions.space(14);

    .notifCard__head {
      gap: functions.space(12);
    }
  }

  &[data-style="filled"] {
    &[data-variant="error"] {
      --notif-backgroud-color: rgba(var(--theme-state-error-base));
    }
    &[data-variant="warning"] {
      --notif-backgroud-color: rgba(var(--theme-state-warning-base));
    }
    &[data-variant="success"] {
      --notif-backgroud-color: rgba(var(--theme-state-success-base));
    }
    &[data-variant="information"] {
      --notif-backgroud-color: rgba(var(--theme-state-information-base));
    }
    &[data-variant="feature"] {
      --notif-backgroud-color: rgba(var(--theme-state-faded-base));
    }
    &[data-variant="promise"] {
      --notif-backgroud-color: rgba(var(--theme-state-information-base));
    }
  }
  &[data-style="light"] {
    &[data-variant="error"] {
      --notif-backgroud-color: rgba(var(--theme-state-error-light));
    }
    &[data-variant="warning"] {
      --notif-backgroud-color: rgba(var(--theme-state-warning-light));
    }
    &[data-variant="success"] {
      --notif-backgroud-color: rgba(var(--theme-state-success-light));
    }
    &[data-variant="information"] {
      --notif-backgroud-color: rgba(var(--theme-state-information-light));
    }
    &[data-variant="feature"] {
      --notif-backgroud-color: rgba(var(--theme-state-faded-light));
    }
    &[data-variant="promise"] {
      --notif-backgroud-color: rgba(var(--theme-state-information-light));
    }
  }
  &[data-style="lighter"] {
    &[data-variant="error"] {
      --notif-backgroud-color: rgba(var(--theme-state-error-lighter));
    }
    &[data-variant="warning"] {
      --notif-backgroud-color: rgba(var(--theme-state-warning-lighter));
    }
    &[data-variant="success"] {
      --notif-backgroud-color: rgba(var(--theme-state-success-lighter));
    }
    &[data-variant="information"] {
      --notif-backgroud-color: rgba(var(--theme-state-information-lighter));
    }
    &[data-variant="feature"] {
      --notif-backgroud-color: rgba(var(--theme-state-faded-lighter));
    }
    &[data-variant="promise"] {
      --notif-backgroud-color: rgba(var(--theme-state-information-lighter));
    }
  }
  &[data-style="stroke"] {
    --notif-border-color: rgba(var(--theme-stroke-soft-200));
    &[data-variant="error"] {
      --notif-backgroud-color: rgba(var(--theme-bg-white-0));
    }
    &[data-variant="warning"] {
      --notif-backgroud-color: rgba(var(--theme-bg-white-0));
    }
    &[data-variant="success"] {
      --notif-backgroud-color: rgba(var(--theme-bg-white-0));
    }
    &[data-variant="information"] {
      --notif-backgroud-color: rgba(var(--theme-bg-white-0));
    }
    &[data-variant="feature"] {
      --notif-backgroud-color: rgba(var(--theme-bg-white-0));
    }
    &[data-variant="promise"] {
      --notif-backgroud-color: rgba(var(--theme-bg-white-0));
    }
  }
}

:global .toastBody {
  border-radius: functions.radius(8) !important;
  padding: 0 !important;
  opacity: 1 !important;
}

:global .Toastify__toast-body {
  margin: 0 0 !important ;
  padding: 0 !important;
}

:global .Toastify__toast {
  box-shadow: unset !important;
  min-height: unset !important;
}

:global .toast {
  border-radius: functions.radius(8) !important;
  padding: 0 !important;
  backface-visibility: hidden;
}

:global .Toastify__toast--stacked[data-collapsed="true"]:not(:last-child) > * {
  opacity: 1 !important;

  & > div {
    & > div {
      & > * {
        opacity: 0 !important;
      }
    }
  }
}
